var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Components, TwapAdapter, Styles as TwapStyles, getConfig, hooks, Styles, useTwapContext, compact, size, Configs, stateActions, } from "@orbs-network/twap-ui";
import translations from "./i18n/en.json";
import { createContext, useContext, useEffect, useMemo } from "react";
import Web3 from "web3";
import { memo, useCallback, useState } from "react";
import { StyledBalance, StyledPanelInput, StyledTokenChange, StyledTokenPanel, StyledTokenSelect, StyledUSD, StyledPoweredBy, darkTheme, lightTheme, StyledLimitSwitch, Card, StyledLimitInput, StyledSelectButton, StyledLimitPanel, StyledTradeIntervalInput, StyledTradeIntervalResolution, StyledTradeInterval, StyledResetLimitButtonContainer, StyledResetLimitButtonLeft, StyledResetLimitButtonRight, StyledChunksSelect, StyledChunksSelectInput, StyledContent, StyledSmallText, StyledBalanceWarning, StyledTop, StyledTwap, StyledOrdersContent, StyledLimitPriceTitle, GlobalStyles, StyledOrdersButton, StyledCreateOrderModal, StyledOrdersHeader, StyledNetworkSelect, StyledLimitAndInputs, StyledChunksWarning, StyledLimitPanelExpiration, StyledLimitPanelExpirationButtons, StyledLimitPanelExpirationButton, StyledTokenPanelLabel, StyledChunksSelectText, } from "./styles";
import { IoMdClose } from "@react-icons/all-files/io/IoMdClose";
import BN from "bignumber.js";
import { BsArrowDownShort } from "@react-icons/all-files/bs/BsArrowDownShort";
import { IoWalletSharp } from "@react-icons/all-files/io5/IoWalletSharp";
import { MdInfo } from "@react-icons/all-files/md/MdInfo";
import { eqIgnoreCase, network } from "@defi.org/web3-candies";
import { ThemeProvider } from "styled-components";
import { TimeResolution } from "@orbs-network/twap-ui";
var configs = [Configs.SushiArb, Configs.SushiBase, Configs.SushiEth];
var USD = function (_a) {
    var usd = _a.usd;
    return (_jsx(StyledUSD, __assign({ className: "twap-custom-usd" }, { children: _jsx(SmallText, { prefix: "$ ", value: BN(usd || 0).isZero() ? "0.00" : usd }) })));
};
var uiPreferences = {
    disableThousandSeparator: true,
    addressPadding: {
        start: 5,
        end: 3,
    },
    infoIcon: _jsx(MdInfo, { size: 15 }),
};
var ModifiedTokenSelectModal = function (props) {
    var _a = useAdapterContext(), TokenSelectModal = _a.TokenSelectModal, srcToken = _a.srcToken, dstToken = _a.dstToken;
    return (_jsx(TokenSelectModal, __assign({ selected: props.isSrc ? srcToken : dstToken, onSelect: props.onSelect }, { children: _jsx(StyledTokenSelect, { hideArrow: false, isSrc: props.isSrc, onClick: function () { } }) })));
};
var memoizedTokenSelect = memo(ModifiedTokenSelectModal);
var TokenSelect = function (_a) {
    var open = _a.open, onClose = _a.onClose, isSrcToken = _a.isSrcToken;
    return _jsx(Components.TokenSelectModal, { Component: memoizedTokenSelect, isOpen: open, onClose: onClose, isSrc: isSrcToken });
};
var SmallText = function (_a) {
    var _b = _a.value, value = _b === void 0 ? "" : _b, prefix = _a.prefix;
    var splitted = value === null || value === void 0 ? void 0 : value.split(".");
    var nums = splitted === null || splitted === void 0 ? void 0 : splitted[0];
    var decimals = splitted === null || splitted === void 0 ? void 0 : splitted[1];
    return (_jsxs(StyledSmallText, { children: [prefix, nums, decimals && _jsxs("small", { children: [".", decimals] })] }));
};
var Balance = function (_a) {
    var isSrc = _a.isSrc;
    var onClick = hooks.useOnSrcAmountPercent();
    var _balance = hooks.useTokenBalance(isSrc);
    var isZeroBalance = BN(_balance || 0).eq(0);
    var balance = hooks.useFormatDecimals(_balance, 2);
    return (_jsxs(StyledBalance, __assign({ disabled: !isSrc ? 1 : 0, onClick: !isZeroBalance ? function () { return onClick(1); } : function () { } }, { children: [_jsx(IoWalletSharp, {}), _jsx(SmallText, { value: isZeroBalance ? "0.00" : balance })] })));
};
var TokenChange = function () {
    return _jsx(StyledTokenChange, { icon: _jsx(BsArrowDownShort, {}) });
};
var TokenPanelUsd = function (_a) {
    var isSrc = _a.isSrc, exceedsBalance = _a.exceedsBalance;
    var _b = hooks.useUsdAmount(), srcUsd = _b.srcUsd, dstUsd = _b.dstUsd;
    var usd = hooks.useFormatDecimals(isSrc ? srcUsd : dstUsd, 2);
    if (exceedsBalance) {
        return _jsx(StyledBalanceWarning, { children: "Exceeds Balance" });
    }
    return _jsx(USD, { usd: usd });
};
var TokenPanel = function (_a) {
    var isSrcToken = _a.isSrcToken;
    var _b = useState(false), tokenListOpen = _b[0], setTokenListOpen = _b[1];
    var isLimitPanel = useTwapContext().isLimitPanel;
    var onClose = useCallback(function () {
        setTokenListOpen(false);
    }, []);
    var insufficientFunds = hooks.useBalanceWarning();
    var exceedsBalance = !isSrcToken ? undefined : insufficientFunds;
    var hideAmounts = !isSrcToken && !isLimitPanel;
    return (_jsx(_Fragment, { children: _jsxs(StyledTokenPanel, __assign({ error: exceedsBalance ? 1 : 0 }, { children: [_jsx(StyledTokenPanelLabel, { children: isSrcToken ? (!isLimitPanel ? "Allocate" : "Sell") : "Buy" }), _jsxs(TwapStyles.StyledColumnFlex, __assign({ gap: 12 }, { children: [_jsxs(TwapStyles.StyledRowFlex, __assign({ style: { marginTop: 8, justifyContent: "space-between" } }, { children: [_jsx(StyledPanelInput, { placeholder: "0.0", isSrc: isSrcToken, hide: hideAmounts ? 1 : 0 }), _jsx(TokenSelect, { onClose: onClose, open: tokenListOpen, isSrcToken: isSrcToken })] })), _jsxs(TwapStyles.StyledRowFlex, __assign({ style: { justifyContent: "space-between" } }, { children: [!hideAmounts && _jsx(TokenPanelUsd, { exceedsBalance: !!exceedsBalance, isSrc: isSrcToken }), _jsx(Balance, { isSrc: isSrcToken })] }))] }))] })) }));
};
var useParseToken = function () {
    var _a = useAdapterContext(), config = _a.config, getTokenLogo = _a.getTokenLogo;
    return useCallback(function (token) {
        var nativeToken = network(config.chainId).native;
        try {
            if (!token || !token.symbol) {
                return;
            }
            if (token.isNative) {
                return __assign(__assign({}, nativeToken), { logoUrl: getTokenLogo(token) || nativeToken.logoUrl });
            }
            return {
                address: Web3.utils.toChecksumAddress(token.address),
                decimals: token.decimals,
                symbol: token.symbol,
                logoUrl: getTokenLogo(token),
            };
        }
        catch (error) {
            console.error("Invalid token", token);
        }
    }, [config.chainId, getTokenLogo]);
};
var AdapterContext = createContext({});
var AdapterContextProvider = AdapterContext.Provider;
var useAdapterContext = function () { return useContext(AdapterContext); };
var useWToken = function () {
    var context = useAdapterContext();
    return useMemo(function () {
        var _a;
        var wTokenAddress = network(context.config.chainId).wToken.address;
        return (_a = context.dappTokens) === null || _a === void 0 ? void 0 : _a.find(function (it) { return eqIgnoreCase(it.address || "", wTokenAddress || ""); });
    }, [context.dappTokens, context.config]);
};
var useIsNative = function () {
    var context = useAdapterContext();
    return useCallback(function (token) {
        if ((token === null || token === void 0 ? void 0 : token.isNative) || (token === null || token === void 0 ? void 0 : token.symbol) === network(context.config.chainId).native.symbol) {
            return true;
        }
    }, [context.config.chainId]);
};
var useAddresses = function () {
    var _a;
    var context = useAdapterContext();
    var wrappedAddress = (_a = useWToken()) === null || _a === void 0 ? void 0 : _a.address;
    var isNative = useIsNative();
    return useMemo(function () {
        var _a, _b;
        return {
            srcAddress: isNative(context.srcToken) ? wrappedAddress : (_a = context.srcToken) === null || _a === void 0 ? void 0 : _a.address,
            dstAddress: isNative(context.dstToken) ? wrappedAddress : (_b = context.dstToken) === null || _b === void 0 ? void 0 : _b.address,
        };
    }, [context.srcToken, context.dstToken, isNative, wrappedAddress]);
};
var useMarketPrice = function () {
    var useTrade = useAdapterContext().useTrade;
    var _a = useAddresses(), srcAddress = _a.srcAddress, dstAddress = _a.dstAddress;
    var srcToken = useSelectedParsedTokens().srcToken;
    var amount = hooks.useAmountBN(srcToken === null || srcToken === void 0 ? void 0 : srcToken.decimals, "1");
    var trade = useTrade(srcAddress, dstAddress, BN(amount || 0).isZero() ? undefined : amount);
    return trade === null || trade === void 0 ? void 0 : trade.outAmount;
};
var useUsd = function () {
    var context = useAdapterContext();
    var _a = useAddresses(), srcAddress = _a.srcAddress, dstAddress = _a.dstAddress;
    var wTokenAddress = network(context.config.chainId).wToken.address;
    return {
        srcUsd: context.useUSD(srcAddress),
        dstUsd: context.useUSD(dstAddress),
        nativeUsd: context.useUSD(wTokenAddress),
    };
};
var useSelectedParsedTokens = function () {
    var context = useAdapterContext();
    var parseToken = useParseToken();
    return useMemo(function () {
        return {
            srcToken: parseToken(context.srcToken),
            dstToken: parseToken(context.dstToken),
        };
    }, [context.srcToken, context.dstToken, parseToken]);
};
var supportedChains = configs.map(function (config) { return config.chainId; });
export var useProvider = function () {
    var context = useAdapterContext();
    var _a = useState(undefined), provider = _a[0], setProvider = _a[1];
    var setProviderFromConnector = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setProvider(undefined);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ((_a = context.connector) === null || _a === void 0 ? void 0 : _a.getProvider())];
                case 2:
                    res = _b.sent();
                    setProvider(res);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [setProvider, context.connector, context.connectedChainId, context.account]);
    useEffect(function () {
        setProviderFromConnector();
    }, [setProviderFromConnector]);
    return provider;
};
var useParsedTokens = function () {
    var context = useAdapterContext();
    var parseToken = useParseToken();
    return useMemo(function () {
        if (!size(context.dappTokens)) {
            return [];
        }
        var parsed = context.dappTokens.map(function (rawToken) {
            return parseToken(rawToken);
        });
        return compact(parsed);
    }, [context.dappTokens, parseToken]);
};
var useIsWrongChain = function () {
    var context = useAdapterContext();
    return useMemo(function () {
        if (!context.configChainId) {
            return false;
        }
        return !supportedChains.includes(context.configChainId);
    }, [context.configChainId]);
};
var CustomButton = function (props) {
    var context = useAdapterContext();
    if (context.Button) {
        return (_jsx("div", __assign({ onClick: props.onClick, style: { width: "100%" }, className: "twap-custom-button" }, { children: _jsx(context.Button, __assign({ disabled: props.disabled || props.loading }, { children: props.children })) })));
    }
    return null;
};
var TWAPContent = function () {
    var context = useAdapterContext();
    var provider = useProvider();
    var theme = useMemo(function () {
        return context.isDarkTheme ? darkTheme : lightTheme;
    }, [context.isDarkTheme]);
    var parsedTokens = useParsedTokens();
    var _a = useSelectedParsedTokens(), srcToken = _a.srcToken, dstToken = _a.dstToken;
    var _b = useUsd(), srcUsd = _b.srcUsd, dstUsd = _b.dstUsd, nativeUsd = _b.nativeUsd;
    var marketPrice = useMarketPrice();
    var isWrongChain = useIsWrongChain();
    var dappWToken = useWToken();
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(StyledTwap, __assign({ className: "twap-adapter-wrapper" }, { children: _jsxs(TwapAdapter, __assign({ config: context.config, maxFeePerGas: context.maxFeePerGas, priorityFeePerGas: context.priorityFeePerGas, translations: translations, provider: provider, account: !context.configChainId ? undefined : context.account, dappTokens: context.dappTokens, parsedTokens: parsedTokens, srcToken: srcToken, dstToken: dstToken, onDstTokenSelected: context.onDstTokenSelected, onSrcTokenSelected: context.onSrcTokenSelected, isLimitPanel: context.limit, uiPreferences: uiPreferences, onSwitchTokens: context.onSwitchTokens, srcUsd: srcUsd, dstUsd: dstUsd, marketPrice: marketPrice, chainId: context.connectedChainId, isWrongChain: isWrongChain, Components: { Tooltip: context.Tooltip, Button: context.Button && CustomButton }, dappWToken: dappWToken, isExactAppoval: true, fee: "0.25", nativeUsd: nativeUsd }, { children: [_jsx(GlobalStyles, {}), _jsxs(StyledContent, { children: [context.limit ? _jsx(LimitPanel, {}) : _jsx(TWAPPanel, {}), _jsx(Components.LimitPriceMessage, {}), _jsx(Orders, {}), _jsx(StyledPoweredBy, {})] }), _jsx(SubmitOrderModal, {})] })) })) })));
};
var TWAP = function (props) {
    var config = useMemo(function () {
        return getConfig(configs, props.configChainId);
    }, [props.configChainId]);
    return (_jsx(AdapterContextProvider, __assign({ value: __assign(__assign({}, props), { config: config }) }, { children: _jsx(TWAPContent, {}) })));
};
var Orders = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var Modal = useAdapterContext().Modal;
    var onClose = useCallback(function () {
        setIsOpen(false);
    }, []);
    return (_jsxs(Components.OrderHistory, __assign({ isOpen: isOpen }, { children: [_jsx(StyledOrdersButton, { onClick: function () { return setIsOpen(true); } }), _jsx(Modal, __assign({ open: isOpen, onClose: onClose, header: _jsx(StyledOrdersHeader, {}) }, { children: _jsx(StyledOrdersContent, {}) }))] })));
};
var SubmitOrderModal = function () {
    var _a = hooks.useSwapModal(), isOpen = _a.isOpen, onClose = _a.onClose, swapState = _a.swapState;
    var Modal = useAdapterContext().Modal;
    return (_jsx(Modal, __assign({ open: isOpen, onClose: function () { return onClose(); }, title: !swapState ? "Review order" : "" }, { children: _jsx(StyledCreateOrderModal, {}) })));
};
var LimitInput = function (props) {
    return _jsx(StyledLimitInput, { placeholder: "0", onChange: props.onChange, value: props.value, loading: props.isLoading });
};
var LimitPercentButton = function (props) {
    return (_jsx(StyledSelectButton, __assign({ onClick: props.onClick, selected: props.selected ? 1 : 0 }, { children: props.text === "0%" ? "Market" : props.text })));
};
var LimitPriceZeroButton = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (_jsxs(StyledResetLimitButtonContainer, { children: [_jsx(StyledResetLimitButtonLeft, __assign({ selected: 1, onClick: onClick }, { children: text })), _jsx(StyledResetLimitButtonRight, __assign({ selected: 1, onClick: onClick }, { children: _jsx(IoMdClose, {}) }))] }));
};
var LimitPriceTokenSelect = function (props) {
    return _jsx(TokenSelect, { onClose: function () { }, open: true, isSrcToken: props.isSrcToken });
};
var LimitPriceTitleTokenSelectModal = function (props) {
    var adapterContext = useAdapterContext();
    var twapContext = useTwapContext();
    var token = props.isSrc ? twapContext.srcToken : twapContext.dstToken;
    return (_jsx(adapterContext.TokenSelectModal, __assign({ selected: props.isSrc ? adapterContext.srcToken : adapterContext.dstToken, onSelect: props.onSelect }, { children: _jsx(Components.Base.TokenDisplay, { symbol: token === null || token === void 0 ? void 0 : token.symbol, logo: token === null || token === void 0 ? void 0 : token.logoUrl }) })));
};
var LimitPriceTitleTokenSelect = function (props) {
    return _jsx(Components.TokenSelectModal, { Component: LimitPriceTitleTokenSelectModal, isOpen: false, onClose: function () { }, isSrc: props.isSrcToken });
};
var LimitPriceTitle = function (props) {
    return (_jsxs(StyledLimitPriceTitle, { children: [_jsx("span", { children: props.textLeft }), _jsx(LimitPriceTitleTokenSelect, __assign({}, props)), _jsx("span", { children: props.textRight })] }));
};
var LimitPrice = function () {
    return (_jsx(StyledLimitPanel, { children: _jsxs(Card, { children: [_jsx(Card.Header, { children: _jsx(StyledLimitSwitch, {}) }), _jsx(Card.Body, { children: _jsx(Components.LimitPanel.Main, { onSrcSelect: function () { }, Components: { Input: LimitInput, PercentButton: LimitPercentButton, ZeroButton: LimitPriceZeroButton, TokenSelect: LimitPriceTokenSelect, Title: LimitPriceTitle }, onDstSelect: function () { }, styles: {
                            percentButtonsGap: "5px",
                        } }) })] }) }));
};
var ShowConfirmationButton = function () {
    var context = useAdapterContext();
    var isWrongChain = useTwapContext().isWrongChain;
    if (isWrongChain && context.NetworkSelector) {
        return (_jsx(context.NetworkSelector, { children: _jsx(StyledNetworkSelect, { children: _jsx(Components.Base.Button, __assign({ className: "twap-submit-button", onClick: function () { } }, { children: "Switch network" })) }) }));
    }
    return _jsx(Components.ShowConfirmation, { connect: context.connect });
};
var TwapListener = function () {
    var onChange = stateActions.useOnLimitMarketSwitch();
    useEffect(function () {
        onChange(true);
    }, [onChange]);
    return null;
};
var TWAPPanel = function () {
    return (_jsxs(StyledContent, { children: [_jsx(TwapListener, {}), _jsxs(StyledTop, { children: [_jsx(TokenPanel, { isSrcToken: true }), _jsx(TokenChange, {}), _jsx(TokenPanel, {})] }), _jsx(TradeIntervalSelect, {}), _jsx(TotalTrades, {}), _jsx(ShowConfirmationButton, {})] }));
};
var LimitPanel = function () {
    return (_jsxs(StyledContent, { children: [_jsxs(StyledLimitAndInputs, { children: [_jsx(LimitPrice, {}), _jsxs(StyledTop, { children: [_jsx(TokenPanel, { isSrcToken: true }), _jsx(TokenChange, {}), _jsx(TokenPanel, {})] })] }), _jsx(LimitPanelExpiration, {}), _jsx(TradeSizeWarning, {}), _jsx(ShowConfirmationButton, {})] }));
};
var LimitPanelExpirationOptions = [
    {
        text: "1 Day",
        value: TimeResolution.Days,
    },
    {
        text: "1 Week",
        value: TimeResolution.Weeks,
    },
    {
        text: "1 Month",
        value: TimeResolution.Months,
    },
    {
        text: "1 Year",
        value: TimeResolution.Years,
    },
];
var LimitPanelExpiration = function () {
    var selectedExpiry = hooks.useDuration().millis;
    var setCustomDuration = stateActions.useSetCustomDuration();
    var onChange = useCallback(function (resolution) {
        setCustomDuration({ resolution: resolution, amount: 1 });
    }, [setCustomDuration]);
    return (_jsxs(StyledLimitPanelExpiration, { children: [_jsx(Components.Labels.MaxDurationLabel, {}), _jsx(StyledLimitPanelExpirationButtons, { children: LimitPanelExpirationOptions.map(function (it) {
                    return (_jsx(StyledLimitPanelExpirationButton, __assign({ onClick: function () { return onChange(it.value); }, selected: selectedExpiry === it.value ? 1 : 0 }, { children: it.text }), it.value));
                }) })] }));
};
var TradeSizeWarning = function () {
    var warning = hooks.useTradeSizeWarning();
    if (!warning)
        return null;
    return _jsx(StyledChunksWarning, { title: warning, variant: "warning" });
};
var TotalTrades = function () {
    return (_jsxs(Card, { children: [_jsx(Card.Header, { children: _jsx(Components.Labels.TotalTradesLabel, {}) }), _jsx(StyledChunksSelect, { children: _jsx(Styles.StyledRowFlex, __assign({ style: { alignItems: "stretch" } }, { children: _jsxs(StyledChunksSelectInput, { children: [_jsx(Components.ChunkSelector.Input, {}), _jsx(StyledChunksSelectText, { children: "Orders" })] }) })) })] }));
};
var TradeIntervalSelect = function () {
    return (_jsxs(Card, { children: [_jsx(Card.Header, { children: _jsx(Components.TradeInterval.Label, {}) }), _jsx(StyledTradeInterval, { children: _jsxs(Styles.StyledRowFlex, __assign({ style: { alignItems: "stretch" } }, { children: [_jsx(StyledTradeIntervalInput, { children: _jsx(Components.TradeInterval.Input, {}) }), _jsx(StyledTradeIntervalResolution, { children: _jsx(Components.TradeInterval.Resolution, {}) })] })) })] }));
};
var isSupportedChain = function (chainId) {
    return Boolean(configs.find(function (config) { return config.chainId === chainId; }));
};
export { TWAP, isSupportedChain, supportedChains };
